import React, {useState} from "react";
import {setSimulateurObject} from "../../../actions/simulateur.action";
import {useDispatch} from 'react-redux';
import {styles} from "../../../stylesheets/simulateurs.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import {ToolTipPerso} from "../../../components/selects/tooltip_perso";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";

// Radiations simplifiées
// simu id 102

function Simulateur_A1_17(props) {
    const dispatch = useDispatch();

    let currUser = JSON.parse(localStorage.getItem("user"));
    let currUserDep = 0
    if (currUser.societe_zip.startsWith("97")){
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 3);
        currUserDep = parseInt(trimedZip)
    } else {
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 2);
        currUserDep = parseInt(trimedZip)
    }

    const [departement, setDepartement] = useState(0)
    const [montant_creance, setMontantCreance] = useState(0)
    const [pouvoir, setMontantPouvoir] = useState(0)
    const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
    const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);

    const handleChange = async (setter, value) => {
        if (setter === setDepartement) {
            setDepartement(parseInt(value))
        } else setter(value);
        setInRedux(setter, value)
    };

    const handleChangeRemarque = async (value) => {
        localStorage.setItem("remarque", value)
    }

    function setInRedux(setter, value) {
        if (props.isParent) {

            let object = {
                "simulateurid": props.simulateur.id,
                "departementid": 0,
                "inputs": {}
            };

            if (setter === setMontantCreance) {
                Object.assign(object['inputs'], {'montant_creance': parseInt(value)})
                Object.assign(object['inputs'], {'montant_pouvoir': parseInt(pouvoir)})
                Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
                Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
                object.departementid = parseInt(departement)
            }

            if (setter === setMontantPouvoir) {
                Object.assign(object['inputs'], {'montant_creance': parseInt(montant_creance)})
                Object.assign(object['inputs'], {'montant_pouvoir': parseInt(value)})
                Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
                Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
                object.departementid = parseInt(departement)
            }

            if (setter === setDepartement) {
                Object.assign(object['inputs'], {'montant_creance': parseInt(montant_creance)})
                Object.assign(object['inputs'], {'montant_pouvoir': parseInt(pouvoir)})
                Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
                Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
                object.departementid = parseInt(value)
            }

            if (setter === setMontantDeboursAdditionnels) {
                Object.assign(object['inputs'], {'montant_creance': parseInt(montant_creance)})
                Object.assign(object['inputs'], {'montant_pouvoir': parseInt(pouvoir)})
                Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
                Object.assign(object["inputs"], { debours_additionnels: parseInt(deboursAdditionnels) });
                object.departementid = parseInt(departement)
            }

            if (setter === setDeboursAdditionnels) {
                Object.assign(object['inputs'], {'montant_creance': parseInt(montant_creance)})
                Object.assign(object['inputs'], {'montant_pouvoir': parseInt(pouvoir)})
                Object.assign(object["inputs"], { montant_deb_add: parseInt(montantDeboursAdditionnels) });
                Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
                object.departementid = parseInt(departement)
            }

            dispatch(setSimulateurObject(object));

        } else {

            // process child simu

        }
    }

    return (
        <div style={styles.container}>
            <div className="cardSimulateur">
                <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id}/>

                <TextfieldRemarques handleChange={handleChangeRemarque}/>

                {props?.isParent === true && props.departements !== "" ?
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>
                            Département :
                        </div>

                        <SelectDepartement items={props.departements} nameField={"name"} defaultValue={currUserDep} optionValue={"id"}
                                      handleChange={handleChange} setter={setDepartement}/>
                    </div>
                    :
                    <></>
                }

                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Indiquer le montant de la créance inscrite au bordereau (si définitive) ou le montant du bien
                        dégrevé déclaré à l'acte (si partielle) :
                        <ToolTipPerso title={"Principal + accessoires éventuels."}/>
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        setter={setMontantCreance}
                    />
                </div>

                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Indiquer les frais de pouvoir à régler à la banque en Euros :
                        <ToolTipPerso title={"Les frais de pouvoir facturés en sus par un établissement bancaire sont à indiquer."}/>
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        setter={setMontantPouvoir}
                    />
                </div>

                <DeboursQuestion
                    handleChange={handleChange}
                    deboursAdditionnels={deboursAdditionnels}
                    setDeboursAdditionnels={setDeboursAdditionnels}
                    setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
                />

            </div>
        </div>
    )
}

export default Simulateur_A1_17;
